import CONSTANTS from '../../../utils/constants'

/**
 * Returns true only when the CIF is having the 9 char length.
 * @param cif 
 * @returns {boolean}
 */ 
export const isValidCIF = (cif: string): boolean => {
    return /^\d{9}$/.test(cif);
  };

  /**
   *  Validation againest the CRM Entity ID.
   *  Valid CRM Entity ID Values =  [1-9]
   *  returns 'true' when the source value met with the target values.
   * */
export const isValidCRMEntityID = (CRMEntityID: string): boolean => {
    return /^\d{1,10}$/.test(CRMEntityID);
  };

export function matchCompaniesWithUserPorfolio(xCompanies: any[], userCompanies: any[]): any[] {
    const matched: any[] = xCompanies.map( xCo => {
        const isAddedToPortfolio = userCompanies.includes(xCo.companyId);
        const previewCrmEntityIdNCif = [];
        if(isValidCRMEntityID(xCo.crmEntityId)) previewCrmEntityIdNCif.push(`CRM Entity ID: ${xCo.crmEntityId}`);
        if(isValidCIF(xCo.cif)) previewCrmEntityIdNCif.push(`CIF: ${xCo.cif}`);
        return { ...xCo, previewCrmEntityIdNCif: previewCrmEntityIdNCif.join(', '), isAddedToPortfolio };
    })
    return matched;
}

/**
 * Matches a company from Xavier with a user portfolio companies.
 *
 * @param currentTab
 * @param xCompanies
 * @param watchListCompanies
 * @param userCompanies
 *
 * @return {Array}
 */
export function byCurrentTab(currentTab: string | null, xCompanies: any[], watchListCompanies: any[], userCompanies: any[]): any[] {
    if (currentTab === CONSTANTS.FDM_DASHBOARD.TAB_CONFIGS.WATCHLIST.value)
        xCompanies = watchListCompanies;
    return matchCompaniesWithUserPorfolio(xCompanies, userCompanies);
}

/**
 * Combines the filters (search, toggles, etc.) for a company.
 *
 * @param companies
 * @param searchText
 * @param isActiveStatusFilterOn
 * @param isApplyTeamCodeFilterOn
 * @param isHiddenStatusFilterOn
 * @param isMyPortfolio
 * @param userTeamCodes
 * @param selectedChips
 *
 * @return {Array}
 */
export function bySearchAndSelections(
    companies: any[],
    searchText: string,
    isActiveStatusFilterOn: boolean,
    isApplyTeamCodeFilterOn: boolean,
    isHiddenStatusFilterOn: boolean,
    isMyPortfolio: boolean,
    userTeamCodes: any[],
    selectedChips: any[],
): any[] {
    const lowerCaseSearchText = searchText?.toLowerCase()
    const setOfChips = new Set(selectedChips.map((c) => c.label))

    const filtered = companies?.filter((c) => {

        const matchesSearchText = !searchText
            ? true
            : c?.name?.toLowerCase().includes(lowerCaseSearchText) ||
            c?.codatCompanyId?.includes(lowerCaseSearchText) ||
            c?.cif?.includes(searchText) ||
            c?.teamCode?.toLowerCase().includes(lowerCaseSearchText)||
            c?.crmEntityId?.includes(searchText) ;

        const isFilteredBYHiddenStatus =  filterCompanyByHiddenStatus(c, isHiddenStatusFilterOn)
        const isFilteredByTeamCode = filterCompanyByTeamCode (c, isApplyTeamCodeFilterOn, isMyPortfolio, userTeamCodes)
        const isInMyPortfolio =  filterCompanyInPortfolio(c, isMyPortfolio)

        const isInActive = c?.status === 'Inactive';
        const isNotHidden = !c?.hidden ;

        const matchesChips = filterByChips(c, setOfChips)

        return matchesSearchText && (isFilteredBYHiddenStatus || isNotHidden) && (isFilteredByTeamCode || isInMyPortfolio) && (!isInActive || isActiveStatusFilterOn) && matchesChips;
    })


    return filtered;
}

/**
 *
 * @param company
 * @param ishHiddenStatusFilterOn
 *
 * @return {boolean}
 */
function filterCompanyByHiddenStatus(company, ishHiddenStatusFilterOn: boolean): boolean {
    return ishHiddenStatusFilterOn && company?.hidden;
}

/**
 *
 * @param company
 * @param isApplyTeamCodeFilterIncluded
 * @param isMyPortfolio
 * @param userTeamCodes
 *
 * @return {boolean}
 */
function filterCompanyByTeamCode(company, isApplyTeamCodeFilterIncluded: boolean, isMyPortfolio: boolean, userTeamCodes: any[]): boolean {
    let matchesTeamCode = (isApplyTeamCodeFilterIncluded || isMyPortfolio)
        ?  userTeamCodes.includes(company.teamCode)
        : true;

    matchesTeamCode = (!isApplyTeamCodeFilterIncluded && isMyPortfolio) ? false : matchesTeamCode;
    return matchesTeamCode
}

/**
 *
 * @param company
 * @param isMyPortfolio
 *
 * @return {boolean}
 */
export const filterCompanyInPortfolio = (company, isMyPortfolio: boolean): boolean => {
    return isMyPortfolio && company?.isAddedToPortfolio;
}

/**
 *
 * @param company
 * @param setOfChips
 *
 * @return {boolean}
 */
export function filterByChips(company: any, setOfChips: Set<string>): boolean {
    if (setOfChips.has(CONSTANTS.WATCHLIST.ISSUES.CONNECTION_ISSUES) && !(company?.codatConnectionStatus !== 'Linked')) return false;
    if (setOfChips.has(CONSTANTS.WATCHLIST.ISSUES.MISSING_WORKBOOK) && !(company?.workbookStatus !== 'Generated')) return false;
    if (setOfChips.has(CONSTANTS.WATCHLIST.ISSUES.UNBUCKETED_ACCOUNTS) && !(company?.unResolvedAccounts && company?.unResolvedAccounts !== '0')) return false;
    if (setOfChips.has(CONSTANTS.WATCHLIST.ISSUES.BOOKS_CLOSURE) && !(['HIGH', 'MEDIUM'].includes(company?.bookClosureStatus))) return false;
    return true;
}

// Note: in theory this could go inside filterCompanies. If filterCompanies returned displayable companies AND
// the issueCount (like a tuple), then we could avoid having to iterate over all companies again.

/**
 *
 * @param filteredCompanies
 *
 * @return {Map<String, Number>}
 */
export function countIssues(filteredCompanies: any[]): Map<string, number> {
    const issueCounts = new Map<string, number>();

    const connection = CONSTANTS.WATCHLIST.ISSUES.CONNECTION_ISSUES
    const missing = CONSTANTS.WATCHLIST.ISSUES.MISSING_WORKBOOK
    const unbucketed = CONSTANTS.WATCHLIST.ISSUES.UNBUCKETED_ACCOUNTS
    const closure = CONSTANTS.WATCHLIST.ISSUES.BOOKS_CLOSURE

    issueCounts.set(connection, 0)
    issueCounts.set(missing, 0)
    issueCounts.set(unbucketed, 0)
    issueCounts.set(closure, 0)

    filteredCompanies.forEach((company) => {
        if (company.codatConnectionStatus !== 'Linked')
            issueCounts.set(connection, issueCounts.get(connection)! +  1)

        if (company.workbookStatus !== 'Generated')
            issueCounts.set(missing, issueCounts.get(missing)! +  1)

        if (company?.unResolvedAccounts && company?.unResolvedAccounts !== '0')
            issueCounts.set(unbucketed, issueCounts.get(unbucketed)! +  1)

        if (['HIGH', 'MEDIUM'].includes(company?.bookClosureStatus))
            issueCounts.set(closure, issueCounts.get(closure)! +  1)
    })

    return issueCounts;
}

interface ActiveTabType {
    isWatchlist: boolean;
    isAllCompanies: boolean;
    isMyPortfolio: boolean;
}

/**
 * This function will return the flag by filterType.
 * @param filterType
 * @return {isWatchlist: true, isAllCompanies: false}
 */
export const getActiveTab = (filterType: string): ActiveTabType => {
    return {
        isWatchlist: CONSTANTS.FDM_DASHBOARD.TAB_CONFIGS.WATCHLIST.value === filterType,
        isAllCompanies: CONSTANTS.FDM_DASHBOARD.TAB_CONFIGS.ALL_COMPANIES.value === filterType,
        isMyPortfolio: CONSTANTS.FDM_DASHBOARD.TAB_CONFIGS.PORTFOLIO.value === filterType
    };
};


export function sortTeamCodes(selected: any[], teamCodes: any[]): any[] {
    return [
        ...selected.sort(),
        ...(selected.length && selected.includes('') ? [] : ['']),
        ...teamCodes.filter((option) => !selected.includes(option)),
    ];
}